/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.FORMULA_ROW.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {FetchRequest, FormulaRowInput, FormulaRow, UUID} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the creation of a new
 * formula_row on the server. Only name, description and formula_row type need to be specified for this purpose.
 * @param formula_rowInput An object of type FormulaRowInput containing the input data for creating the formula_row.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_create_formula_row(formula_rowInput: FormulaRowInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.FORMULA_ROW,
        method: HttpMethods.POST,
        query_parameters: {},
        body: formula_rowInput,
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * formula_row on the server.
 * @param formula_row An object of type FormulaRow containing the updated formula_row data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_formula_row(formula_row: FormulaRow): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.FORMULA_ROW,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: formula_row,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of formula_rows
 * on the server.
 * @param formula_id Optional. The UUID of the formula to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_formula_rows(formula_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.FORMULA_ROW,
        method: HttpMethods.GET,
        query_parameters: { formula_id: formula_id },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * formula_row on the server.
 * @param formula_row_id The UUID of the formula_row to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_formula_row(formula_row_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.FORMULA_ROW,
        method: HttpMethods.DELETE,
        query_parameters: { formula_row_id: formula_row_id },
    };
}
